      <div class="lightbox" data-lightbox hidden role="dialog" aria-modal="true"
           aria-label="Büyütülmüş fotoğraf" data-i18n-attr="aria-label:lb.label">
        <button class="lightbox-close" type="button" data-lb-close
                aria-label="Kapat" data-i18n-attr="aria-label:lb.close">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
        <button class="lightbox-nav lightbox-nav--prev" type="button" data-lb-prev
                aria-label="Önceki kare" data-i18n-attr="aria-label:cf.prev">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>
        </button>
        <button class="lightbox-nav lightbox-nav--next" type="button" data-lb-next
                aria-label="Sonraki kare" data-i18n-attr="aria-label:cf.next">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>
        </button>

        <figure class="lightbox-figure">
          <img data-lb-img alt="" decoding="async">
        </figure>
        <p class="lightbox-count" data-lb-count aria-live="polite"></p>
      </div>
